<script>
import appConfig from "@/app.config";
import listQuestions from "./list_questions.vue";
import listTryoutQuestion from "./list_tryout_question.vue";
import listTryoutKecermatan from "./list_questions_kecermatan.vue";

/**
 * Starter page
 */
export default {
  components: { listQuestions, listTryoutQuestion, listTryoutKecermatan },
  page: {
    title: "Student",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "CBT - Siswa",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Student",
          active: true,
        },
      ],
      params: this.$route.params,
      isLoading: true,
      setRespv: null,
      setPaketSoal: [],
      setListPaketSoal: null,
      setDataSearch: [],
      selectedFilter: null,
      selected: null,
      options: [
        { value: null, text: "Pilih Jenis Paket", disabled: true },
        { value: "", text: "Semua" },
        { value: "1", text: "Ujian" },
        { value: "0", text: "Latihan/TryOut" },
      ],
      errorMessage: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {},
  middleware: "authentication",
};
</script>
<style scoped>
.bg-custom {
  background-color: var(--bs-indigo);
}
.border-custom {
  border-color: #adb5bd !important;
}
.custom-select {
  padding: 0.75rem !important;
  font-size: 1rem !important;
}
</style>
<template>
  <div>
    <div v-if="this.params.subid && this.params.programname !== 'latihan'">
      <list-tryout-question />
    </div>

    <div
      v-else-if="
        params.subid &&
          params.programname == 'latihan' &&
          params.subname == 'kecermatan'
      "
    >
      <list-tryout-kecermatan />
    </div>

    <div v-else>
      <list-questions />
    </div>
  </div>
</template>
